import { action, computed, observable } from 'mobx'
import PT from 'prop-types'
import R from 'ramda'

import i18n from '#utils/i18n'
import {
  SIMPLIFIED_VIEW,
  CALENDAR_VIEW,
  PREFERENCES_VIEW_KEY,
  stringToViewMap,
  viewToStringMap,
} from '#utils/booking'

const tp = i18n.prefix('components.CreateBooking')

const mkStore = (
  _request,
  props,
  { users }
) => {
  const {
    preferences: preferencesStore,
  } = users.self

  const store = observable({
    preferencesKey: PREFERENCES_VIEW_KEY,

    availableViews: computed(() =>
      R.pipe(
        R.keys,
        R.map(
          (view) => ({
            disabled: props.disabled,
            label: tp(`${view}-booking`), // eslint-disable-line @vimcar/i18n/no-complex-args
            view,
          })
        )
      )(stringToViewMap)
    ),
    _defaultView: computed(() =>
      store._stringToView(
        preferencesStore.map.get(PREFERENCES_VIEW_KEY)
      )
    ),
    defaultView: computed(() =>
      store._viewToString(store._defaultView)
    ),
    isSimplified: computed(() =>
      store._defaultView === SIMPLIFIED_VIEW
    ),
    isCalendar: computed(() =>
      store._defaultView === CALENDAR_VIEW
    ),

    handleChange: action((view) => {
      if (view in stringToViewMap) {
        props.updateUserPreferences({
          [PREFERENCES_VIEW_KEY]: view,
        })
      }
    }),

    _viewToString: (view) => viewToStringMap[view],
    _stringToView: (str) => stringToViewMap[str],
  })

  return store
}

mkStore.propTypes = {
  disabled: PT.bool,
  updateUserPreferences: PT.func.isRequired,
}

mkStore.contextTypes = {
  users: PT.object.isRequired,
}

export default mkStore
